// --------------------Custom Mobile Menu----------------------//
import { SEARCH_ICON, CLOSE_ICON, isMobileBreakpoint } from './utils.js';

// --------------------Quick Fixes----------------------//

function modifyBtnNavToggle() {
  const navToggle = $('.mobile-nav-toggle');
  const navToggleLine = $('<span class="nav-toggle-line">Explore</span>');
  const bars = `<span class="mobile-nav-toggle-bar"></span><span class="mobile-nav-toggle-bar"></span><span class="mobile-nav-toggle-bar"></span>`;
  navToggle.html(bars);
  navToggle.wrap(navToggleLine);
  navToggle.attr('tabindex', '0');
  navToggle.attr('role', 'button');
  navToggle.attr('aria-label', 'open menu');
}

function searchBoxPlaceholder() {
  const searchInput = $('header .inputFieldTextbox');
  const header_searchbtn = $('header .searchSubmitButton');
  header_searchbtn.html(SEARCH_ICON);

  // set a placeholder to searchInput
  searchInput.attr('placeholder', 'Search');
  searchInput.val('');
}

function clonedSearchIcons() {
  console.log('search');
  const mobile_closebtn = $('.clonedSearchBox .mobileSearchCloseButton');
  mobile_closebtn.html(CLOSE_ICON);
}

// --------------------Navigation Changes----------------------//

function modifyNavBlank() {
  const navItem = $('nav .item[aria-haspopup=true] > a');

  navItem.each((x, item) => {
    const navItemText = item.innerHTML;
    // remove &nbsp;&nbsp;
    item.innerHTML = navItemText.replaceAll('&nbsp;', '');
  });
}

function hideUpcomingEvents(navItems) {
  // if navItems children <a> text is "Upcoming Events" hide the item
  navItems.each((i, item) => {
    if ($(item).text().toLowerCase().includes('upcoming events')) {
      $(item).addClass('hideNavItem');
    }
  });
}

function addPlusIcon(nav) {
  // find all the .item[aria-haspopup=true] and append a span with class "next-level"
  const spanExists = nav.find('.next-level-btn').length > 0;
  if (!isMobileBreakpoint && !spanExists) {
    nav.find('.item[aria-haspopup=true] > a').each((i, item) => {
      $(item).append('<span class="next-level">+</span>');
    });
  }
}

function modifyHeaderItems() {
  const nav = $('#mainNavigation ul.groups');
  const navItems = nav.find('> li');
  modifyNavBlank();
  addPlusIcon(nav);
  hideUpcomingEvents(navItems);
}

// --------------------Footer----------------------//

function removeHomeFooter() {
  $('.footer-navigation__item > a').each((i, item) => {
    if ($(item).text().includes('Home')) {
      $(item).parent().remove();
    }
  });
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  modifyBtnNavToggle();
  searchBoxPlaceholder();
  modifyHeaderItems();
  removeHomeFooter();

  $('.searchBox').on('click', () => {
    clonedSearchIcons();
  });
});

$(window).load(() => {
  $('.socialNetworks').clone().appendTo('.socialwidget-desktop');

  // Sub Page Label picture
  let labelData = $('.media-container .media-text-Container .textMediaPhotoCaption span').text();
  if (labelData == '') {
    $('.media-container .media-text-Container').addClass('hideComp');
  }
});
